import React, { FC } from 'react'
import Step1ModalButtons from './Step1ModalButtons'
import Spinner from '../Spinner'
import ModalContainer from '../Modal/ModalContainer'
import { IStep1ModalProps } from '../../interfaces/Step'
import Step1ModalDocumentPreview from './Step1ModalDocumentPreview'
import Step1ModalText from './Step1ModalText'

const Step1Modal: FC<IStep1ModalProps> = (props) => {
  const { openDocumentModal, previewIsLoading } = props

  return (
    <ModalContainer isOpen={openDocumentModal}>
      <div className="modalDialog">
        {!previewIsLoading ? (
          <div className="px35 py35 textLeft">
            <Step1ModalText {...props} />
            <Step1ModalDocumentPreview {...props} />
            <Step1ModalButtons {...props} />
          </div>
        ) : (
          <div className="py35">
            <Spinner small={true} />
          </div>
        )}
      </div>
    </ModalContainer>
  )
}

export default Step1Modal
